export default __webpack_public_path__ + "static/banner1-60f927b2dbab97f8c8acea4f38a8282c.jpg";